import React from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import Root from './components/Root';
import Listing from './components/Listing';
import SubPage from './components/SubPage';
import ListingMap from './components/ListingMap';
import PropertyMap from './components/PropertyMap';
import BuyerList from './components/BuyerList';
import SellerList from './components/SellerList';
import AgentList from './components/AgentList';
import FirmList from './components/FirmList';
import TenantList from './components/TenantList';
import LenderList from './components/LenderList';
import TeamMemberList from './components/TeamMemberList';
import Stats from './components/Stats';
import GeoCoder from './components/GeoCoder';
import Pipeline from './components/Pipeline';
import Inventory from './components/Inventory';
import AgentPipeline from './components/AgentPipeline';
import AgentCommissionBreakdown from './components/AgentCommissionBreakdown';
import Error404 from './components/Error404';
import Super from './components/Super';
import EscrowTracking from "./components/EscrowTracking/EscrowTracking";
import SuperAgent from './components/SuperAgent';
import AgentPipelineDetails from './components/AgentPipelineDetails/AgentPipelineDetails';
import BuyerStateBreakdown from './components/BuyerStateBreakdown';
import ListingFilter from './components/ListingFilter';
import SellerListFilter from "./components/SellerListFilter";
import AgentListFilter from "./components/AgentListFilter";
import FirmListFilter from "./components/FirmListFilter";
import TenantListFilter from "./components/TenantListFilter";
import TeamMemberListFilter from "./components/TeamMemberListFilter";
import RoverListFilter from "./components/RoverListFilter";
import TransactionBreakdown from "./components/TransactionBreakdown";
import UploadCostarFile from "./components/UploadCostarFile";
import MarketTransactionBreakdown from './components/MarketTransactionBreakdown/MarketTransactionBreakdown';
import PropertyStatistics from "./components/PropertyStatistics";
import BuyerListFilter from "./components/BuyerListFilter";
import Buckets from "./components/Buckets/Buckets";
import BucketsDetails from "./components/BucketsDetails/BucketsDetails";
import StriveFees from "./components/StriveFees";
import CRUDProperty from './components/CRUDProperty';
import CRUDTenant from './components/CRUDTenant';
import CRUDLender from './components/CRUDLender';
import CRUDFirm from './components/CRUDFirms';
import CRUDAgent from './components/CRUDAgent';
import CRUDBuyer from './components/CRUDBuyer';
import CRUDSeller from './components/CRUDSeller';
import HscPipeline from "./components/HscPipeline/HscPipeline";
import HscTracking from "./components/HscTracking/HscTracking";
import LenderListFilter from "./components/LenderListFilter";
import HscPipelineFees from "./components/HscPipelineFees";
import Training from "./components/Training";
import TrainingSwitch from "./components/TrainingSwitch/TrainingSwitch";
import ChapterContentSwitch from "./components/ChapterContentSwitch/ChapterContentSwitch";
import AgentCommissionDetails from "./components/AgentCommissionDetails/AgentCommissionDetails";
import MarketShareReport from './components/MarketShareReport/MarketShareReport';
import PipelineByStatus from './components/PipelineByStatus/PipelineByStatus';
import HscStats from './components/HscStats/HscStats';
import CRUDTeamMember from './components/CRUDTeamMember';
import { Provider } from 'react-redux';
import store from './components/Redux/store';
import { ApolloProvider } from '@apollo/client';
import client from './components/Graphql/client';
import StriveVision from './components/StriveVision';
import SampleTable from './components/ReactTable/SampleTable';
import Contacts from './components/CRM/Contacts';
import Company from './components/CRM/Company';
import InvestorListFilter from './components/InvestorListFilter/InvestorListFilter';
import InvestorList from './components/InvestorList/InvestorList';
import CRUDInvestor from './components/CRUDInvestors/CRUDInvestor';
import MergingUI from './components/CRM/MergingUI';

import HscHotlist from './components/HscHotlist/HscHotlist';
import HotlistPipelineDetails from './components/HotlistPipelineDetails/HotlistPipelineDetails';
import CRUDProposal from './components/CRUDProposal';
import VendorListFilter from './components/VendorListFilter/VendorListFilter';
import VendorList from './components/VendorList/VendorList';
import CRUDVendor from './components/CRUDVendor/CRUDVendor';
import users from './components/userNew/CRUDUser';
import CRUDUser from './components/userNew/CRUDUser';
import UserList from './components/userNew/UserList';
import UserListFilter from './components/UserListFilter.js/UserListFilter';
import EventsList from './components/EventsList/EventsList';
import Event from './components/Event/Event';
import EventListFilter from './components/EventListFilter/EventListFilter';
import News from './components/News/News';
import NewsList from './components/NewsList/NewsList';
import NewsListFilter from './components/NewsListFilter/NewsListFilter';
import { restrictRoute } from './routeGuards';
import Unauthorized from "./Unauthorized"
import StatsOrListingWrapper from './StatsOrListingWrapper';
import SeniorSuper from './components/SeniorSuper/SeniorSuper';
import Symposium from './components/Symposium/Symposium';
// import "bootstrap/dist/css/bootstrap.min.css";

export default (
	
	<ApolloProvider client={client}>
		<Provider store={store}>
				<Router history={browserHistory}>
				<Route path="unauthorized" component={Unauthorized} />
				<Route path={arc.path.base} component={Root} onEnter={restrictRoute}>
					{/* <IndexRoute component={(props) => props.userData.email.includes('highstcapital.com') ? <AthenaCapStats {...props} /> : <Stats {...props} />} /> */}
					<IndexRoute component={StatsOrListingWrapper} onEnter={restrictRoute} />
					<Route path='stats' component={Stats} onEnter={restrictRoute} />
					<Route component={(props) => <ListingFilter client={client} {...props} />} >
						<Route path='list' component={Listing} onEnter={restrictRoute} />
						<Route path='map' component={ListingMap} onEnter={restrictRoute} />
						<Route path='map/:id' component={(props) => <PropertyMap client={client} {...props} />} onEnter={restrictRoute} >
						</Route>
						<Route path='buyer-state-breakdown' component={BuyerStateBreakdown} onEnter={restrictRoute} />
						<Route path='transaction-breakdown' component={TransactionBreakdown} onEnter={restrictRoute} />
						<Route path='market-transaction-breakdown' component={MarketTransactionBreakdown} onEnter={restrictRoute} />
						<Route path='market-share' component={MarketShareReport} onEnter={restrictRoute} />
					</Route>
					<Route component={SuperAgent} onEnter={restrictRoute}>
						<Route component={(props) => <ListingFilter client={client} {...props} />} >
							<Route path='property'>
								<IndexRoute component={CRUDProperty} onEnter={restrictRoute} />
								<Route path=':id' component={(props) => <CRUDProperty {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						<Route component={BuyerListFilter}>
							<Route path='buyers' component={BuyerList} onEnter={restrictRoute} />
						</Route>
						<Route path='agent-pipeline' component={AgentPipeline} onEnter={restrictRoute} />
						<Route path='agent-pipeline/:id' component={(props) => <AgentPipelineDetails {...props} isAgentPipeline />} onEnter={restrictRoute} />
						<Route path='buckets' component={Buckets} onEnter={restrictRoute} />
						<Route path='buckets/:id' component={BucketsDetails} onEnter={restrictRoute} />
						<Route path='strive-fees' component={StriveFees} onEnter={restrictRoute} />
						<Route path='property-statistics/:id' component={PropertyStatistics} onEnter={restrictRoute} />
						<Route path='pipeline' component={Pipeline} onEnter={restrictRoute} />
						<Route path='pipeline/:status' component={PipelineByStatus} onEnter={restrictRoute} />
						<Route path='inventory' component={Inventory} onEnter={restrictRoute} />
						<Route path='escrow-tracking' component={(props) => <EscrowTracking client={client} {...props} />} onEnter={restrictRoute} >
							<Route path=':id' />
						</Route>
						<Route path='training' component={Training} onEnter={restrictRoute} />
						<Route path='symposium' component={Symposium} onEnter={restrictRoute} />
						<Route path='training/:slug' component={TrainingSwitch} onEnter={restrictRoute} />
						<Route path='training/:slug/:slug2' component={ChapterContentSwitch} onEnter={restrictRoute}>
							<Route path=':slug3'>
								<Route path=':slug4'>
									<Route path=':slug5'>
										<Route path=':slug6'>
											<Route path=':slug7'>
												<Route path=':slug8'>
													<Route path=':slug9'>
														<Route path=':slug10' />
													</Route>
												</Route>
											</Route>
										</Route>
									</Route>
								</Route>
							</Route>
						</Route>
						{/* <Route component={RoverListFilter}>
							<Route path='rover' component={StriveVision} onEnter={restrictRoute} />
						</Route> */}
						<Route path="rover" component={RoverListFilter} onEnter={restrictRoute}>
							<IndexRoute component={StriveVision} />
						</Route>
						<Route path='contacts' component={Contacts} onEnter={restrictRoute} />
						<Route path="company" component={Company} onEnter={restrictRoute} />
						<Route path='contacts/:id' component={SampleTable} onEnter={restrictRoute} />
						<Route path='company/:id' component={SampleTable} onEnter={restrictRoute} />
						<Route path="merging/:id" component={MergingUI} onEnter={restrictRoute} />
						<Route path="merging/:id/:id" component={MergingUI} onEnter={restrictRoute} />
					</Route>
		    <Route component={SeniorSuper} onEnter={restrictRoute}>
				<Route path='agent-commission-breakdown' component={AgentCommissionBreakdown} onEnter={restrictRoute}/>
				<Route path='agent-commission-breakdown/:year/:id/procured' component={AgentCommissionDetails} onEnter={restrictRoute}/>
				<Route path='agent-commission-breakdown/:year/:id/paid' component={AgentCommissionDetails} onEnter={restrictRoute}/>
				<Route path='proposals' component={CRUDProposal} onEnter={restrictRoute}/>
			</Route>
					<Route component={Super} onEnter={restrictRoute}>
						{/* <Route component={TeamMemberListFilter}>
							<Route path='teamMembers' component={TeamMemberList} />
						</Route>
						<Route component={InvestorListFilter}>
							<Route path='investors' component={InvestorList} />
						</Route>
						<Route component={SellerListFilter}>
							<Route path='sellers' component={SellerList} />
						</Route>
						<Route component={AgentListFilter}>
							<Route path='agents' component={AgentList} />
						</Route>
						<Route component={FirmListFilter}>
							<Route path='firms' component={FirmList} />
						</Route>
						<Route component={TenantListFilter}>
							<Route path='tenants' component={TenantList} />
						</Route>
						<Route component={LenderListFilter}>
							<Route path='lenders' component={LenderList} />
						</Route>
						<Route component={VendorListFilter}>
							<Route path='vendors' component={VendorList} />
						</Route> */}
						<Route path='agent-commission-breakdown' component={AgentCommissionBreakdown} onEnter={restrictRoute} />
						<Route path='agent-commission-breakdown/:year/:id/procured' component={AgentCommissionDetails} onEnter={restrictRoute} />
						<Route path='agent-commission-breakdown/:year/:id/paid' component={AgentCommissionDetails} onEnter={restrictRoute} />
						<Route path='strive-fees' component={StriveFees} onEnter={restrictRoute} />
						<Route path='hsc-pipeline' component={HscPipeline} onEnter={restrictRoute} />
						<Route path='hsc-pipeline/:id' component={HscPipelineFees} onEnter={restrictRoute} />
						<Route path='hsc-tracking' component={(props) => <HscTracking client={client} {...props} />} onEnter={restrictRoute} >
							<Route path=':id' />
						</Route>
						<Route path='hsc-stats' component={HscStats} onEnter={restrictRoute} />
						<Route path='hsc-hotlist' component={HscHotlist} onEnter={restrictRoute} />
						<Route path='hsc-hotlist/:id/:email' component={(props) => <HotlistPipelineDetails {...props} isAgentPipeline />} onEnter={restrictRoute} />
						<Route component={SubPage}>
							<Route path='geocoder'>
								<IndexRoute component={(props) => <GeoCoder client={client} {...props} />} onEnter={restrictRoute} ></IndexRoute>
							</Route>
							<Route path='upload-file' component={UploadCostarFile} onEnter={restrictRoute} />
						</Route>
						<Route component={FirmListFilter}>
							<Route path='firm'>
								<IndexRoute component={CRUDFirm} onEnter={restrictRoute} />
								<Route path=':id' component={(props) => <CRUDFirm {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						<Route component={TenantListFilter}>
							<Route path='tenant'>
								<IndexRoute component={CRUDTenant} onEnter={restrictRoute} />
								<Route path=':id' component={(props) => <CRUDTenant {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						<Route component={LenderListFilter}>
							<Route path='lender'>
								<IndexRoute component={CRUDLender} onEnter={restrictRoute} />
								<Route path=':id' component={(props) => <CRUDLender {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						<Route component={AgentListFilter}>
							<Route path='agent'>
								<IndexRoute component={CRUDAgent} onEnter={restrictRoute} />
								<Route path=':id' component={(props) => <CRUDAgent {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						{/* <Route path='buyer'>
							<IndexRoute component={CRUDBuyer} />
							<Route path=':id' component={(props) => <CRUDBuyer {...props} edit />} />
						</Route> */}
						<Route component={InvestorListFilter}>
							<Route path='investor'>
								<IndexRoute component={CRUDInvestor} onEnter={restrictRoute} />
								<Route path=':id' component={(props) => <CRUDInvestor {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						{/* <Route path='seller'>
							<IndexRoute component={CRUDSeller} />
							<Route path=':id' component={(props) => <CRUDSeller {...props} edit />} />
						</Route> */}
						<Route component={TeamMemberListFilter}>
							<Route path='teamMember'>
								<IndexRoute component={CRUDTeamMember} onEnter={restrictRoute} />
								<Route path=':id/:email' component={(props) => <CRUDTeamMember {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						<Route path='proposals' component={CRUDProposal} onEnter={restrictRoute} />
						<Route component={VendorListFilter}>
							<Route path='vendor'>
								<IndexRoute component={CRUDVendor} onEnter={restrictRoute} />
								<Route path=':id' component={(props) => <CRUDVendor {...props} edit />} onEnter={restrictRoute} />
							</Route>
						</Route>
						{/* <Route component={UserListFilter}>
							<Route path='userList' component={UserList} onEnter={restrictRoute} />
						</Route>
						<Route path='users'>
							<IndexRoute component={CRUDUser} onEnter={restrictRoute} />
							<Route path=':id' component={(props) => <CRUDUser {...props} edit />} onEnter={restrictRoute} />
						</Route> */}
							{/* </Route> */}
						{/* <Route path='user'>
							<IndexRoute component={CRUDUser} />
							<Route path=':id' component={(props) => <CRUDUSer {...props} edit />} />
						</Route> */}
						<Route component={EventListFilter}>
							<Route path='events' component={EventsList} onEnter={restrictRoute} />
						</Route>
						<Route path='event'>
							<IndexRoute component={Event} onEnter={restrictRoute} />
							<Route path=':id' component={(props) => <Event {...props} edit />} onEnter={restrictRoute} />
						</Route>
						<Route component={NewsListFilter}>
							<Route path='news-list' component={NewsList} onEnter={restrictRoute} />
						</Route>
						<Route path='news'>
							<IndexRoute component={News} onEnter={restrictRoute} />
							<Route path=':id' component={(props) => <News {...props} edit />} onEnter={restrictRoute} />
						</Route>
					</Route>
					<Route path='*' component={Error404} />
				</Route>
			</Router>

		</Provider>
	</ApolloProvider>
);